import React from "react";
import { Clock, Users, UserCog } from "lucide-react";
import { cn } from "@/lib/utils";
import {
  resolveOpsStatus,
  elapsedAgingClass,
  tableGuestCount,
  tableGuestName,
  tableWaiterName,
  tableBillAmount,
} from "@/lib/tableFloorUi";
import { useCurrency } from "@/hooks/useCurrency";
import { money2 } from "@/lib/format";

export default function TableOpsCard({
  table,
  selected,
  mergeTarget,
  onClick,
  compact = false,
  testId,
  className,
  style,
}) {
  const { code: currencyCode } = useCurrency();
  const ops = resolveOpsStatus(table);
  const isVacant = table.status === "Vacant";
  const guestName = tableGuestName(table);
  const waiterName = tableWaiterName(table);
  const guests = tableGuestCount(table);
  const amount = tableBillAmount(table);
  const agingClass = !isVacant ? elapsedAgingClass(table.elapsed_minutes) : "";

  return (
    <button
      type="button"
      data-testid={testId}
      onClick={onClick}
      style={style}
      className={cn(
        "tf-ops-card text-left transition-all",
        ops.card,
        agingClass,
        selected && "tf-ops-card--selected",
        mergeTarget && "tf-ops-card--merge-target",
        compact && "tf-ops-card--compact",
        className,
      )}
    >
      <div className="tf-ops-card-top">
        <span className="tf-ops-table-name">{table.name || table.code}</span>
        {!isVacant && guests != null && (
          <span className="tf-ops-guests" title="Guests">
            <Users size={12} />
            {guests}
          </span>
        )}
      </div>

      {!isVacant ? (
        <>
          {guestName && <div className="tf-ops-guest-name">{guestName}</div>}
          {waiterName && (
            <div className="tf-ops-waiter" title="Waiter">
              <UserCog size={11} />
              <span className="truncate">{waiterName}</span>
            </div>
          )}
          {amount > 0 && (
            <div className="tf-ops-amount">{currencyCode} {money2(amount)}</div>
          )}
          <div className={cn("tf-ops-status-badge", ops.badge)}>
            <span className={cn("tf-ops-dot", ops.dot)} />
            {table.dining_phase_label || ops.label}
          </div>
          {table.elapsed && (
            <div className="tf-ops-elapsed">
              <Clock size={11} />
              {table.elapsed}
            </div>
          )}
        </>
      ) : (
        <>
          <div className="tf-ops-vacant-hint">Tap to seat</div>
          {guests != null && (
            <div className="tf-ops-capacity">
              <Users size={11} />
              {guests} seats
            </div>
          )}
        </>
      )}

      {table.status === "Multi" && (
        <span className="tf-ops-multi">×{table.active_bill_count || 2}</span>
      )}
    </button>
  );
}
